import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './routes';
import { AuthProvider } from './contexts/AuthContext';
import Flex from './components/Flex';

function App(): React.JSX.Element {
  const routeStyle = { width: '100vw', minHeight: '100vh' };

  return (
    <BrowserRouter>
      <AuthProvider>
        <Flex style={routeStyle}>
          <AppRoutes />
        </Flex>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;